/**
 * すでに存在する<meta name="viewport">タグに対して
 * content属性の編集を行うようなユースケースを想定している。
 * したがって、コンストラクタで渡されたHTMLMetaElementを直接操作しており、
 * 全くimmutableな実装にはなっていないことに注意。
 */
export class ViewPort {
  static create(targetElement: HTMLMetaElement): ViewPort {
    return new ViewPort(targetElement)
  }

  private parsedContent: KeyValueMap

  constructor(private targetElement: HTMLMetaElement) {
    this.parse(targetElement.getAttribute('content') || '')
  }

  /**
   * 内部状態 (parsedContent) をmetaタグに反映する
   */
  save(): void {
    this.targetElement.setAttribute(
      'content',
      Object.keys(this.parsedContent).map(key => `${key}=${this.parsedContent[key]}`).join(',')
    )
  }

  withMaximumScale(value: string): ViewPort {
    this.parsedContent = {
      ...this.parsedContent,
      'maximum-scale': this.removeWhiteSpace(value),
    }

    return this
  }

  /**
   * 厳密には;もサポートされるべきかもだがここでは,のみ
   * https://drafts.csswg.org/css-device-adapt/#viewport-meta
   */
  private parse(content: string): void {
    this.parsedContent = this.removeWhiteSpace(content).split(',').map((s) => {
      const equalIndex = s.indexOf('=')

      if (equalIndex <= 0 || equalIndex === s.length - 1) return null

      return {
        key: s.slice(0, equalIndex),
        value: s.slice(equalIndex + 1),
      }
    }).reduce(
      (prev: KeyValueMap, current) => {
        if (!current) return prev

        return {
          ...prev,
          [current.key]: current.value,
        }
      },
      {}
    )
  }

  /**
   * 厳密にはタブや改行も取り除かれるべきらしいがここではスペースのみ
   * https://drafts.csswg.org/css-device-adapt/#viewport-meta
   */
  private removeWhiteSpace(value: string): string {
    return value.replace(/\s/g, '')
  }
}

interface KeyValueMap { [key: string]: string }
